<div class="assign-container">
  <div class="d-flex justify-content-between accent">
    <p>Planning: #{{ subProject.project.id }}</p>
    <mat-icon (click)="close.emit(false)">close</mat-icon>
  </div>

  <mat-spinner *ngIf="loading" color="primary" diameter="75"></mat-spinner>
  <ng-container *ngIf="!loading">
    <div class="row row--quotation">
      <label>Offerte</label>
      <mat-form-field
        class="ctrl ctrl__employee ctrl__employee--quotation"
        appearance="outline"
      >
        <mat-select [(ngModel)]="quotationEmployeeId">
          <mat-option
            *ngFor="let quotationEmployee of quotationHandlerChoices"
            [value]="quotationEmployee.id"
          >
            {{
              quotationEmployee.user.firstName +
                ' ' +
                quotationEmployee.user.lastName
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="ctrl ctrl__date ctrl__date--quotation"
        appearance="outline"
      >
        <input
          matInput
          [(ngModel)]="quotationDate"
          [matDatepicker]="pickerQuotation"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerQuotation"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerQuotation></mat-datepicker>
      </mat-form-field>
    </div>

    <ng-container *ngIf="subProject.type !== 'Repo'">
      <div class="row row--design">
        <label>Ontwerp</label>
        <mat-form-field
          class="ctrl ctrl__employee ctrl__employee--design"
          appearance="outline"
        >
          <mat-select [(ngModel)]="designEmployeeId">
            <mat-option
              *ngFor="let designEmployee of designerChoices"
              [value]="designEmployee.id"
            >
              {{
                designEmployee.user.firstName +
                  ' ' +
                  designEmployee.user.lastName
              }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="ctrl ctrl__date ctrl__date--design"
          appearance="outline"
        >
          <input
            matInput
            [(ngModel)]="designDate"
            [matDatepicker]="pickerDesign"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerDesign"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerDesign></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="row row--printwork">
        <label>Printwerk</label>
        <mat-form-field
          class="ctrl ctrl__employee ctrl__employee--printwork"
          appearance="outline"
        >
          <mat-select [(ngModel)]="printworkEmployeeId">
            <mat-option
              *ngFor="let printworkEmployee of printworkHandlerChoices"
              [value]="printworkEmployee.id"
            >
              {{
                printworkEmployee.user.firstName +
                  ' ' +
                  printworkEmployee.user.lastName
              }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="ctrl ctrl__date ctrl__date--printwork"
          appearance="outline"
        >
          <input
            matInput
            [(ngModel)]="printworkDate"
            [matDatepicker]="pickerPrintwork"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerPrintwork"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerPrintwork></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="row row--finish">
        <label>Afwerking</label>
        <mat-form-field
          class="ctrl ctrl__employee ctrl__employee--finish"
          appearance="outline"
        >
          <mat-select [(ngModel)]="finishEmployeeId">
            <mat-option
              *ngFor="let finishEmployee of finisherChoices"
              [value]="finishEmployee.id"
            >
              {{
                finishEmployee.user.firstName +
                  ' ' +
                  finishEmployee.user.lastName
              }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="ctrl ctrl__date ctrl__date--finish"
          appearance="outline"
        >
          <input
            matInput
            [(ngModel)]="finishDate"
            [matDatepicker]="pickerFinish"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerFinish"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerFinish></mat-datepicker>
        </mat-form-field>
      </div>
    </ng-container>

    <div class="row row--placement">
      <label>Plaatsing</label>
      <mat-form-field
        class="ctrl ctrl__employee ctrl__employee--placement"
        appearance="outline"
      >
        <mat-select [(ngModel)]="placementEmployeeId">
          <mat-option
            *ngFor="let placementEmployee of placerChoices"
            [value]="placementEmployee.id"
          >
            {{
              placementEmployee.user.firstName +
                ' ' +
                placementEmployee.user.lastName
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="ctrl ctrl__date ctrl__date--placement"
        appearance="outline"
      >
        <input
          matInput
          [(ngModel)]="placementDate"
          [matDatepicker]="pickerPlacement"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerPlacement"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerPlacement></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="row row--action">
      <button (click)="submitAssign()" class="btn btn--submit">
        Opslaan
      </button>
    </div>
  </ng-container>
</div>
